module.exports = __webpack_public_path__ + "static/media/footer_logo.5bcd5d59.svg";